<template>
  <div style="background:#dedddb" class="gruppi">
    <div class="overlay" v-if="loading">
      <md-progress-spinner
        :md-diameter="100"
        :md-stroke="10"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
    <h1>{{ $t("group.title") }}</h1>

    <div v-if="groupsList" class="groups-list">
      <!-- Banner info e errori -->

      <div class="error" v-if="errorInProgress">
        <span>{{ $t("ballot.state.in-error") }}</span>
      </div>

      <!-- <div class="error" v-if="passwordError">
        {{ $t("group.password-error") }}
      </div> -->
      <div
        class="info"
        v-if="
          !this.pollStatus.END &&
            (pollStatus.IN_PROGRESS > 0 || pollStatus.ON_WAITING > 0)
        "
      >
        <h3 class="scrutinio-incorso">
          {{ $t("ballot.state.in-progress") }}. {{ $t("group.count") }}
          <b>{{ currentCountingTaskDone }}</b>
          {{ $t("group.count-over") }} <b>{{ currentCountingTaskId }}</b>
          {{ $t("group.count-over-elections-selected") }}
        </h3>
      </div>
      <div class="info completed" v-if="sendReportOK">
        <h3>{{ $t("group.gea.info-completed") }}</h3>
      </div>
      <div class="error" v-if="sendError">
        <h3>{{ $t("group.gea.send-error") }}</h3>
        <span>{{ $t("group.gea.error") }}: {{ sendError }}</span>
      </div>

      <div class="selectAll">
        <md-checkbox
          v-model="allSelected"
          @change="selectAll"
          :disabled="status || pollStatus.DONE == groups.length"
          role="checkbox"
          :aria-checked="allSelected"
          ><md-tooltip class="tooltip">{{ $t("group.select.all") }}</md-tooltip
          ><b>{{ $t("group.select.all-checkbox") }}</b></md-checkbox
        >
        <!-- Qui mettere non il poolstatus ma electionStatus-->

        <div class="totCounting">
          <span
            >{{ $t("group.count") }} <b>{{ pollStatus.DONE }}</b>
            {{ $t("group.count-over") }} <b>{{ groups.length }}</b>
            {{ $t("group.count-over-elections-total") }}</span
          >
        </div>
      </div>
      <md-card
        v-for="group in displayedGroups"
        :key="group.Id"
        class="md-layout"
        :class="group.CountingTaskStatus"
      >
        <md-checkbox
          v-model="selected"
          class="md-layout-item md-size-5 md-small-size-10"
          @change="select"
          :value="group.Id"
          :disabled="
            group.CountingTaskStatus == 'DONE' ||
              group.CountingTaskStatus == 'ERROR' ||
              status ||
              pollStatus.ON_WAITING > 0
          "
          ><md-tooltip class="tooltip"
            >{{ $t("group.select.item") }} {{ group.Name }}
          </md-tooltip>
        </md-checkbox>
        <div class="md-layout-item md-size-60 md-small-size-90">
          <span class="group-title">{{ group.Name }} </span>
        </div>

        <div
          class="md-layout-item status md-small-size-100"
          style="text-align:center"
        >
          <md-chip
            v-if="group.CountingTaskStatus == 'DONE'"
            class="completed"
            tabindex="-1"
            >{{ $t("ballot.state.done") }}</md-chip
          >

          <md-chip
            v-else-if="group.CountingTaskStatus == 'IN_PROGRESS'"
            class="counting"
            tabindex="-1"
            >{{ $t("ballot.state.in-progress") }}</md-chip
          >

          <md-chip
            v-else-if="group.CountingTaskStatus == 'ON_WAITING'"
            class="wait"
            tabindex="-1"
            >{{ $t("ballot.state.on-waiting") }}</md-chip
          >

          <md-chip
            v-else-if="group.CountingTaskStatus == 'ERROR'"
            class="errorStatus"
            tabindex="-1"
            >{{ $t("ballot.state.error") }}</md-chip
          >

          <md-chip v-else-if="group.CountingTaskStatus == null" tabindex="-1">{{
            $t("ballot.state.to-count")
          }}</md-chip>
        </div>

        <div
          v-if="group.CountingTaskStatus == 'IN_PROGRESS'"
          class="md-layout-item md-size-20 spinner md-small-size-100"
          style="text-align:center"
        >
          <div class="progressNum">
            <div>{{ calcCompleted(group) }}%</div>
            <div style="font-size:12px">{{ $t("ballot.state.loading") }}</div>
          </div>
          <md-progress-spinner
            v-show="group.CountingTaskStatus == 'IN_PROGRESS'"
            md-mode="determinate"
            :md-diameter="30"
            :md-value="calcCompleted(group)"
          ></md-progress-spinner>
        </div>
        <div
          v-if="group.CountingTaskStatus == 'IN_PROGRESS' && nextCalled"
          class="md-layout-item md-size-20 md-small-size-100 live"
          style="text-align:center"
        >
          <md-button
            ><md-tooltip class="tooltip">{{
              $t("group.go-to-live-button")
            }}</md-tooltip>
            <router-link
              @click="goToScrutinioLive = true"
              :to="'scrutinio/' + group.Id + '/' + page"
              >{{ $t("group.go-to-live-button") }}</router-link
            >
          </md-button>
        </div>
        <div
          v-if="
            group.CountingTaskStatus == 'ON_WAITING' &&
              $store.getters.getElectionMode == 'SEQ' &&
              pollStatus.IN_PROGRESS == 0 &&
              firstSeqOnWaiting == group.Id
          "
          class="action md-layout-item md-size-20 md-small-size-100"
        >
          <md-button
            @click="avviaScrutinioLive()"
            @keydown.enter.space="avviaScrutinioLive()"
            ><md-tooltip class="tooltip">{{
              $t("group.start-live-button")
            }}</md-tooltip>
            {{ $t("group.start-live-button") }}
          </md-button>
        </div>

        <div
          class="action md-layout-item md-size-20 md-small-size-100"
          style="text-align:center"
          v-if="group.CountingTaskStatus == 'DONE'"
        >
          <md-button @click="vediRisultati(group.Id)"
            ><md-tooltip class="tooltip">{{
              $t("group.show-results-button")
            }}</md-tooltip
            >{{ $t("group.show-results-button") }}
            <!-- <router-link :to="'/scrutinio/' + group.Id + '/' + page"
              >Vedi risultati</router-link
            > -->
          </md-button>
          <md-menu>
            <md-button md-menu-trigger class="md-icon-button md-primary">
              <md-icon>
                file_download
              </md-icon>
              <md-tooltip>{{ $t("group.download-results-button") }}</md-tooltip>
            </md-button>
            <md-menu-content>
              <md-menu-item
                v-if="group.ShowPDF"
                @click="download(group.Id, 'pdf')"
                >{{ $t("group.download-button") }} PDF<md-tooltip
                  md-direction="right"
                  >{{ $t("group.download-button") }} PDF</md-tooltip
                ></md-menu-item
              >
              <md-menu-item
                v-if="group.ShowXML"
                @click="download(group.Id, 'xml')"
                >{{ $t("group.download-button") }} XML<md-tooltip
                  md-direction="right"
                  >{{ $t("group.download-button") }} XML</md-tooltip
                ></md-menu-item
              >
              <md-menu-item
                v-if="group.ShowHTML"
                @click="download(group.Id, 'html')"
                >{{ $t("group.download-button") }} HTML<md-tooltip
                  md-direction="right"
                  >{{ $t("group.download-button") }} HTML</md-tooltip
                ></md-menu-item
              >
            </md-menu-content>
          </md-menu>
        </div>

        <div
          v-if="
            group.CountingTaskStatus != 'IN_PROGRESS' &&
              group.CountingTaskStatus != 'DONE'
          "
          class="md-layout-item md-size-20 md-small-size-100"
        ></div>

        <div
          v-if="group.ElectionIdentifier && group.ElectionIdentifier.length > 1"
          class="md-layout-item  md-size-100 sub-group"
        >
          <div
            v-for="subGroup in group.ElectionIdentifier"
            :key="subGroup.Id"
            style="margin-left:6px;"
          >
            {{ subGroup.ElectionName }}
            <span v-if="subGroup.ElectionCategory"
              >({{ subGroup.ElectionCategory }})</span
            >
          </div>
        </div>
      </md-card>

      <!-- paginazione -->
      <nav
        aria-label="Navigazione pagine "
        v-if="pages.length > 1"
        class="paginator"
      >
        <div class="num-page">
          {{ $t("group.pagination.page") }} {{ page }}
          {{ $t("group.pagination.of-page") }} {{ pages.length }}
        </div>
        <ul class="pagination">
          <li class="page-item">
            <md-button
              type="button"
              class="page-link"
              :disabled="page == 1"
              :aria-label="$t('group.pagination.previous-page-label')"
              :aria-disabled="page == 1"
              @click="
                page--;
                pageChanged = true;
                readPageFocus(false);
              "
              ><md-tooltip class="tooltip">{{
                $t("group.pagination.previous-page-label")
              }}</md-tooltip>
              &lt; {{ $t("group.pagination.previous-page-button") }}
            </md-button>
          </li>
          <li class="page-item">
            <md-button
              type="button"
              @click="
                page++;
                pageChanged = true;
                readPageFocus(true);
              "
              :disabled="page == pages.length"
              class="page-link"
              :aria-label="$t('group.pagination.next-page-label')"
              :aria-disabled="page == pages.length"
              ><md-tooltip class="tooltip">{{
                $t("group.pagination.next-page-label")
              }}</md-tooltip>
              {{ $t("group.pagination.next-page-button") }} &gt;
            </md-button>
          </li>
        </ul>
      </nav>
      <div class="finalActions">
        <md-button
          class="md-layout-item  md-raised md-primary"
          @click="
            inSequenza = true;
            callNext = false;
            openPassModal = true;
          "
          :disabled="
            selected.length == 0 || status || pollStatus.ON_WAITING > 0
          "
          ><md-tooltip class="tooltip"
            >{{ $t("group.seq-button") }} ({{ selected.length }})</md-tooltip
          >{{ $t("group.seq-button") }} ({{ selected.length }})
        </md-button>
        <md-button
          class="md-layout-item  md-raised primary-color"
          @click="
            inSequenza = false;
            callNext = false;
            openPassModal = true;
            stopPolling = false;
          "
          :disabled="
            selected.length == 0 || status || pollStatus.ON_WAITING > 0
          "
          ><md-tooltip class="tooltip"
            >{{ $t("group.all-button") }} ({{ selected.length }})</md-tooltip
          >{{ $t("group.all-button") }} ({{ selected.length }})
        </md-button>
        <md-menu
          class="md-layout-item md-size-20 md-small-size-100"
          md-size="big"
        >
          <md-button
            class="md-layout-item md-raised primary-color"
            md-menu-trigger
            :disabled="!hasResults || status"
            ><md-icon>file_download</md-icon>
            <md-tooltip class="tooltip">{{
              $t("group.all-results-button")
            }}</md-tooltip
            >{{ $t("group.all-results-button") }}
          </md-button>
          <md-menu-content>
            <md-menu-item @click="download(null, 'all.pdf')"
              >{{ $t("group.download-button") }} PDF {{ $t("group.unique")
              }}<md-tooltip md-direction="right"
                >{{ $t("group.download-button") }} PDF
                {{ $t("group.unique") }}</md-tooltip
              ></md-menu-item
            >
            <md-menu-item @click="download(null, 'pdf.zip')"
              >{{ $t("group.download-button") }} PDF (zip)<md-tooltip
                md-direction="right"
                >{{ $t("group.download-button") }} PDF (zip)</md-tooltip
              ></md-menu-item
            >
            <md-menu-item @click="download(null, 'xml.zip')"
              >{{ $t("group.download-button") }} XML (zip)<md-tooltip
                md-direction="right"
                >{{ $t("group.download-button") }} XML (zip)</md-tooltip
              ></md-menu-item
            >
            <md-menu-item @click="download(null, 'html.zip')"
              >{{ $t("group.download-button") }} HTML (zip)<md-tooltip
                md-direction="right"
                >{{ $t("group.download-button") }} HTML (zip)</md-tooltip
              ></md-menu-item
            >
            <md-menu-item @click="download(null, 'csv.zip')"
              >{{ $t("group.download-button") }} CSV (zip<md-tooltip
                md-direction="right"
                >{{ $t("group.download-button") }} CSV (zip)</md-tooltip
              >)</md-menu-item
            >
          </md-menu-content>
        </md-menu>
        <md-button
          class="md-layout-item md-raised sendGEA"
          v-if="sendReportToGEA"
          @click="sendReport()"
          ><md-tooltip class="tooltip">{{
            $t("group.gea.send-results-button")
          }}</md-tooltip
          >{{ $t("group.gea.send-results-button") }}
        </md-button>
        <md-button
          class="md-layout-item md-raised primary-color"
          v-if="
            !this.pollStatus.END &&
              pollStatus.ON_WAITING > 0 &&
              inCountingTaskMode == 'SEQ'
          "
          @click="
            callNext = false;
            openPassModal = true;
            stopCounting = true;
          "
          :disabled="status && pollStatus.IN_PROGRESS > 0"
        >
          <md-tooltip class="tooltip">{{ $t("group.stop-button") }}</md-tooltip>
          {{ $t("group.stop-button") }}
        </md-button>
      </div>
    </div>

    <passkey-dialog
      v-if="openPassModal"
      :openPassModal="openPassModal"
      :callNext="callNext"
      @cancel="openPassModal = false"
      @okPasskey="
        stopCounting ? stopScrutinio($event) : iniziaScrutinio($event, callNext)
      "
    ></passkey-dialog>
  </div>
</template>

<script>
// import { isMobile } from "mobile-device-detect";
import PasskeyDialog from "./PasskeyDialog.vue";
export default {
  async mounted() {
    this.$emit("startLoading");
    await this.getGroups();

    if (this.pagination) this.page = this.pagination;
  },
  beforeDestroy: function() {
    //stop polling
    this.pollStatus.END = true;
    clearTimeout(this.timeout);
  },
  data: function() {
    return {
      // isMobile: false,
      groups: null,
      groupsList: false,
      selected: [],
      allSelected: false,
      openPassModal: false,
      page: 1,
      perPage: 10,
      pages: [],
      pageChanged: false,
      refreshPageKey: 0,
      refreshPageTopKey: 0,
      status: false,
      pollInterval: 1000,
      passwordError: false,
      pollStatus: { DONE: 0, IN_PROGRESS: 0, ON_WAITING: 0, END: true },
      timeout: null,
      inSequenza: null,
      inProgressId: null,
      nextCalled: false,
      goToScrutinioLive: false,
      inCountingTaskId: 0,
      inCountingTaskMode: null,
      currentCountingTaskId: 0,
      currentCountingTaskDone: 0,
      seqOnWaiting: [],
      firstSeqOnWaiting: 0,
      callNext: false,
      found: false,
      sendReportToGEA: false,
      sendError: null,
      sendReportOK: false,
      loading: false,
      stopPolling: false,
      stopCounting: false,
      errorInProgress: false
    };
  },
  props: { pagination: String },
  methods: {
    async getGroups() {
      this.loading = true;
      let groups = await this.$store.state.ceoCbbService.countingInformation();
      this.inCountingTaskId = groups.InCountingTaskId;
      this.inCountingTaskMode = groups.InCountingTaskMode;
      this.loading = false;
      if (groups.error) {
        alert(groups.error);
        return;
      }

      this.sendReportToGEA = groups.SendReportToGEA;
      const mode = groups.InCountingTaskMode;
      this.groups = groups.CountingElectionGroup;
      this.setPages(this.groups);
      this.groupsList = true;
      this.$emit("stopLoading");
      this.checkStatus();
      this.previousSelected();

      //Aggiornamento numero scrutini in corso su scrutinate e mantenimento selezioni da scrutinare
      this.currentCountingTaskDone = 0;
      this.currentCountingTaskId = 0;
      this.groups.forEach(group => {
        if (this.inCountingTaskId == group.CountingTaskId) {
          this.currentCountingTaskId = this.currentCountingTaskId + 1;
          if (group.CountingTaskStatus == "DONE")
            this.currentCountingTaskDone = this.currentCountingTaskDone + 1;
          if (group.CountingTaskStatus == "ON_WAITING") {
            if (!this.found) {
              //this.pollStatus.ON_WAITING > 1 &&
              this.firstSeqOnWaiting = group.Id;
              this.found = true;
            }
          }
        }
        if (group.CountingTaskStatus == "ERROR") {
          // errore durante lo scrutinio
          this.errorInProgress = true;
          // this.stopPolling = true;
        }
      });

      //Se c'è uno scrutinio in corso parte il polling
      if (!this.pollStatus.END) {
        this.status = true;
        if (mode == "SEQ") {
          //prendere l'id dell'inprogress o fare next()
          this.$store.commit("electionModeSetter", "SEQ");
          if (this.inProgressId) {
            this.$router
              .push("/scrutinio/" + this.inProgressId + "/1")
              .catch(() => {});
            // controllare prima la password e in caso chiederla
          } else {
            this.nextCalled = true;

            if (
              //this.pollStatus.ON_WAITING > 0 &&
              this.pollStatus.IN_PROGRESS != 1 &&
              this.goToScrutinioLive
            ) {
              //nessuna in progress e clicco su SCRUTINIO LIVE -> next + poll in Scrutinio
              if (!this.$store.getters.getPassKey) {
                this.openPassModal = true;
              } else {
                this.$emit("startLoading");
                this.next(this.$store.getters.getPassKey);
              }
            } else if (
              this.pollStatus.IN_PROGRESS == 1 &&
              !this.goToScrutinioLive
            ) {
              //parte il poll in groupList e si stoppa in Scrutinio
              this.poll(this.pollInterval);
            }
          }
        } else {
          this.$store.commit("electionModeSetter", "ALL");
          this.poll(this.pollInterval);
        }
      }

      //console.log("groups", groups);
    },
    async poll(ms) {
      let results;
      this.status = true;
      if (this.allSelected) this.allSelected = false;

      while (!this.stopPolling) {
        results = await this.$store.state.ceoCbbService.countingStatus();
        if (!results) {
          this.stopPolling = true;
        } else {
          if (results.InCountingTaskId != null) {
            this.inCountingTaskId = results.InCountingTaskId;
            this.inCountingTaskMode = results.InCountingTaskMode;
          }
          results = results.GroupCountingStatusInfo;

          this.pollStatus = {
            DONE: 0,
            IN_PROGRESS: 0,
            ON_WAITING: 0,
            END: false
          };
          this.currentCountingTaskDone = 0;
          this.currentCountingTaskId = 0;

          //("results ", results);

          results.forEach(result => {
            //prendo l'elezione da aggiornare
            let group = this.groups.find(g => g.Id == result.Id);
            //aggiorno elezione e conteggi
            group.CountingTaskStatus = result.CountingTaskStatus;
            group.CountingTaskId = result.CountingTaskId;
            if (result.CountingTaskStatus == "DONE") {
              this.pollStatus.DONE = this.pollStatus.DONE + 1;
            }
            if (result.CountingTaskStatus == "IN_PROGRESS") {
              this.pollStatus.IN_PROGRESS = 1;
              group.CountingFragment = result.CountingFragment;
              group.NumOfFragments = result.NumOfFragments;
            }
            if (result.CountingTaskStatus == "ON_WAITING")
              this.pollStatus.ON_WAITING = this.pollStatus.ON_WAITING + 1;

            if (this.inCountingTaskId == result.CountingTaskId) {
              this.currentCountingTaskId = this.currentCountingTaskId + 1;
              if (result.CountingTaskStatus == "DONE") {
                this.currentCountingTaskDone = this.currentCountingTaskDone + 1;
                group.CountingTaskStatus = result.CountingTaskStatus;
              }
              if (result.CountingTaskStatus == "ERROR") {
                // errore durante lo scrutinio
                this.errorInProgress = true;
                this.stopPolling = true;
              }
            }
          });

          //controllo se lo scrutinio è finito
          if (
            this.pollStatus.ON_WAITING == 0 &&
            this.pollStatus.IN_PROGRESS == 0
          ) {
            this.pollStatus.END = true;
            this.selected = [];
            if (this.nextCalled) this.nextCalled = false;
          }

          //scrutinio finito, clic su SCRUTINIO LIVE o AVVIA SCRUTINIO LIVE, inCountingTaskMode "SEQ" con 0 in progress
          if (
            (this.pollStatus.END &&
              this.pollStatus.IN_PROGRESS == 0 &&
              this.pollStatus.ON_WAITING == 0) ||
            this.goToScrutinioLive ||
            (!this.pollStatus.END &&
              this.pollStatus.IN_PROGRESS == 0 &&
              this.inCountingTaskMode == "SEQ")
          ) {
            this.stopPolling = true;
          }

          /*console.log(
            "Poll: W" +
              this.pollStatus.ON_WAITING +
              ", P" +
              this.pollStatus.IN_PROGRESS +
              ", D" +
              this.pollStatus.DONE
          );*/

          await this.wait(ms);
        }
      }
      if (
        this.pollStatus.ON_WAITING == 0 &&
        this.pollStatus.IN_PROGRESS == 0 &&
        this.pollStatus.END
      )
        this.status = false;
    },
    wait(ms = 1000) {
      return new Promise(resolve => {
        //console.log(`waiting ${ms} ms...`);
        this.timeout = setTimeout(resolve, ms);
      });
    },
    checkStatus() {
      if (!this.stopCounting) {
        this.groups.forEach(group => {
          if (group.CountingTaskStatus == "DONE")
            this.pollStatus.DONE = this.pollStatus.DONE + 1;
          if (group.CountingTaskStatus == "IN_PROGRESS") {
            this.pollStatus.IN_PROGRESS = 1;
            this.inProgressId = group.groupId;
          }
          if (group.CountingTaskStatus == "ON_WAITING")
            this.pollStatus.ON_WAITING = this.pollStatus.ON_WAITING + 1;
        });
        if (this.pollStatus.ON_WAITING != 0 || this.pollStatus.IN_PROGRESS != 0)
          this.pollStatus.END = false;
      }
      /*console.log(
        "CheckStatus: W" +
          this.pollStatus.ON_WAITING +
          ", P" +
          this.pollStatus.IN_PROGRESS +
          ", D" +
          this.pollStatus.DONE
      );*/
    },
    select() {
      const test = this.groups.filter(
        group =>
          group.CountingTaskStatus != "DONE" &&
          group.CountingTaskStatus != "ERROR"
      );
      if (test.length == this.selected.length) this.allSelected = true;
      else this.allSelected = false;
    },
    selectAll: function() {
      this.selected = [];
      if (this.allSelected) {
        this.groups.forEach(group => {
          if (
            group.CountingTaskStatus != "DONE" &&
            group.CountingTaskStatus != "ERROR"
          )
            this.selected.push(group.Id);
        });
      }
    },
    previousSelected() {
      this.groups.forEach(group => {
        if (
          (this.pollStatus.IN_PROGRESS == 1 ||
            this.pollStatus.ON_WAITING > 0) &&
          this.status
        ) {
          if (this.inCountingTaskId == group.CountingTaskId) {
            this.selected.push(group.Id);
          }
        }
      });
    },
    async iniziaScrutinio(password, callNext) {
      this.loading = true;
      window.scrollTo(0, 0);

      this.openPassModal = false;
      this.passwordError = false;
      this.status = false;
      this.inSequenza
        ? this.$store.commit("electionModeSetter", "SEQ")
        : this.$store.commit("electionModeSetter", "ALL");

      let res;
      if (!callNext) {
        //Sia live, sia batch

        //riordino
        this.selected = this.getOrderedSelected(this.selected);
        res = await this.$store.state.ceoCbbService.countingStart(
          password,
          this.selected,
          this.$store.state.electionMode
        );
      } else {
        //Avvia scrutinio live della singola elezione
        this.inSequenza = true;
        res = await this.$store.state.ceoCbbService.nextGroup(password);

        //indice selezionato
      }
      this.loading = false;

      if (res && res.CountingStarted) {
        this.$store.commit("passKeySetter", password);
        if (this.inSequenza) {
          let id = this.selected[0];
          if (this.goToScrutinioLive) {
            id = res.GroupId;
          }
          this.$router
            .push({
              name: "scrutinio",
              params: {
                locale: this.$route.params.locale,
                id: id,
                page: this.page
              }
            })
            .catch(() => {});
        } else {
          this.status = true;
          this.pollStatus.END = false;
          this.poll(this.pollInterval);
        }
      } else {
        this.passwordError = true;
      }
      window.scrollTo(0, 0);
    },
    async stopScrutinio(password) {
      this.loading = true;
      window.scrollTo(0, 0);

      this.openPassModal = false;
      this.passwordError = false;
      this.status = false;

      let response = await this.$store.state.ceoCbbService.stopCounting(
        password
      );
      this.loading = false;

      if (response) {
        if (response.CountingStoped) {
          this.pollStatus.ON_WAITING = 0;
          this.$store.commit("passKeySetter", password);
          await this.getGroups();

          this.selected = [];
          this.status = false;
          this.pollStatus.END = true;
          this.stopCounting = false;
        }
      }
    },
    vediRisultati(id) {
      //stop polling
      this.pollStatus.END = true;
      clearTimeout(this.timeout);
      this.$router
        .push({
          path: `/${this.$route.params.locale}/scrutinio/${id}/${this.page}`
        })
        .catch(() => {});
    },
    setPages(res) {
      this.page = 1;
      let numberOfPages = Math.ceil(res.length / this.perPage);
      this.pages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(posts) {
      this.pageChanged = false;
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return posts.slice(from, to);
    },
    readPageFocus(val) {
      if (val) {
        this.refreshPageKey++;
        this.refreshPageTopKey++;
      } else {
        this.refreshPageKey--;
        this.refreshPageTopKey--;
      }
      this.$forceUpdate();
    },
    calcCompleted(g) {
      if (g.NumOfFragments != 0) {
        this.perc = Math.round((g.CountingFragment / g.NumOfFragments) * 100);
      } else {
        this.perc = 0;
      }
      return this.perc;
    },
    async download(groupId, fileType) {
      let eventId = this.$store.state.retIdentification.ElectionEvent
        .EventIdentifier.Id;
      let response = await this.$store.state.ceoCbbService
        .downloadFile(groupId, fileType)
        .then(function(response) {
          const blobUrl = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          document.body.appendChild(link);
          link.href = blobUrl;
          if (groupId != null) {
            link.download =
              eventId + "_" + groupId + "." + fileType.toLowerCase(); //or any other extension
          } else {
            link.download = eventId + "." + fileType.toLowerCase(); //Tutti i risultati
          }

          link.click();
          setTimeout(() => {
            link.href = "blobUrl";
            window.URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          }, 0);
        })
        .catch(function(error) {});
    },
    avviaScrutinioLive() {
      this.goToScrutinioLive = true;
      this.callNext = true;
      this.nextCalled = true;
      this.inSequenza = true;
      if (!this.$store.getters.getPassKey) {
        this.openPassModal = true;
      } else {
        this.$emit("startLoading");
        this.iniziaScrutinio(this.$store.getters.getPassKey, this.callNext);
      }
    },
    async sendReport() {
      this.loading = true;
      window.scrollTo(0, 0);

      let response = await this.$store.state.ceoCbbService.sendReportToGEA();
      if (response.SendResult == "ERROR") {
        this.sendError = response.SendInformation;
      } else {
        this.sendReportOK = true;
      }
      this.loading = false;

      //console.log(response);
    },
    getOrderedSelected(selectedGroups) {
      let orderedSelected = [];
      this.groups.forEach(group => {
        if (selectedGroups.find(g => g == group.Id)) {
          orderedSelected.push(group.Id);
        }
      });
      return orderedSelected;
    }
  },
  computed: {
    displayedGroups() {
      return this.paginate(this.groups);
    },
    hasResults() {
      let found = null;
      if (this.groups != null) {
        found = this.groups.find(group => group.CountingTaskStatus == "DONE");
      }
      return found !== undefined;
    }
  },
  components: {
    PasskeyDialog
  }
};
</script>
<style scoped>
.totCounting {
  float: right;
  color: #555;
  padding-right: 4px;
}
.error {
  background: #f8d7da;
  padding: 25px;
  margin-bottom: 20px;
  text-align: left;
  font: 400 16px/28px Roboto, "Helvetica Neue", sans-serif;
  font-weight: bold;
  margin: 25px 0;
  color: #721c24;
  border-radius: 3px;
  border: 1px solid #f5c6cb;
}

.info {
  background: #fff3cd;
  padding: 25px;
  margin-bottom: 20px;
  text-align: left;
  font: 400 16px/28px Roboto, "Helvetica Neue", sans-serif;
  color: #735602;
  border-radius: 3px;
  border: 1px solid #e6dbba;
  max-height: 70px;
}

.info h3,
.error h3 {
  margin: 0 0 15px 0;
}

.info span {
  font-style: italic;
}

.paginator {
  margin: 0 auto 40px auto;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  display: inline;
}
button.page-link {
  display: inline-block;
}
button.page-link {
  color: #387a8f;
  background-color: white;
  font-weight: 500;
  border: 1px solid;
  width: 140px;
  height: 30px;
  text-transform: none;
}
button.page-link.selected {
  background: #387a8f;
  color: #fff;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
.num-page {
  margin-top: 20px;
  font-size: 16px;
}
.num-page-top {
  padding-bottom: 5px;
  font-size: 16px;
}

.group-title {
  font-weight: bold;
  font-size: 22px;
  color: #387a8f;
  margin-bottom: 10px;
  letter-spacing: 0;
}

.md-chip {
  font-weight: bold;
  letter-spacing: 0;
  width: 151px;
}

.groups-list .md-checkbox {
  margin: 0;
  justify-content: center;
}

.spinner div {
  display: inline-block;
  line-height: 30px;
  padding-right: 10px;
  vertical-align: top;
}

.progressNum div {
  font-weight: bold;
  line-height: 20px !important;
  display: block;
}

.sub-group {
  padding-left: 4.6%;
  color: #666;
}
.sub-group div {
  margin-bottom: 5px;
}

.gruppi {
  max-width: 1200px;
  margin: 0 auto;
}

.gruppi .md-card a {
  color: #387a8f;
}

.gruppi .md-card .md-button {
  color: #387a8f;
  margin: 0 !important;
  padding: 0 15px !important;
}

span.md-dialog-title {
  background-color: #387a8f !important;
  text-align: center !important;
}

.md-card {
  font-size: 18px !important;
  position: relative;
  z-index: 0;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: all;
  transition-property: color, background-color;
  will-change: color, background-color;
  text-align: left;
  padding: 30px 15px;
  margin: 20px 0px;
  border-left: 4px solid #bbb;
  align-items: center;
}

.md-card .md-title {
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
  background: #fff !important;
}

.counting {
  background: #007bff;
  color: #fff;
}

.completed {
  background: #387a8f;
  color: #fff;
}

.wait {
  background: #ffe270;
  color: #333;
}

.errorStatus {
  background: #f8d7da;
  color: #721c24;
}

.md-card.DONE {
  border-left: 4px solid #387a8f; /*#28a745*/
}
.md-card.IN_PROGRESS {
  border-left: 4px solid #007bff;
}
.md-card.ON_WAITING {
  border-left: 4px solid #ffe270;
}
.md-card.ERROR {
  border-left: 4px solid #f8d7da;
}

.md-button.md-raised:not([disabled]) {
  box-shadow: none !important;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-accent {
  background-color: #387a8f !important;
  box-shadow: none !important;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #387a8f !important;
  color: #fff !important;
}

.md-button.md-theme-default.md-raised.start-count:not([disabled]) {
  color: #3d3d3d !important;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%) !important;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary[data-v-1b949507] {
  background-color: #387a8f !important;
}

.md-button.md-active {
  color: #387a8f !important;
  color: var(--md-theme-default-primary-on-background, #387a8f);
}

.md-button {
  padding: 0 20px !important;
  margin: 6px 10px 6px 10px;
}

.md-title {
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
  text-transform: uppercase;
  text-align: center;
  background: #387a8f;
  color: #fff !important;
  padding-bottom: 20px;
}

.md-caption {
  font-size: 18px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  background: #387a8f;
  color: #fff !important;
  padding-top: 0px;
}

.md-card-header.md-title {
  color: #333 !important;
}

.md-button {
  font-weight: bold;
}
.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #387a8f !important;
}

.md-button.md-theme-default.md-primary .md-icon-font {
  color: #387a8f !important;
  color: var(--md-theme-default-primary-on-background, #387a8f) !important;
}

.md-icon-font:hover {
  color: #333 !important;
  color: var(--md-theme-default-primary-on-background, #333) !important;
}

.md-fab .md-ripple,
.md-fab::before,
.md-icon-button .md-ripple,
.md-icon-button::before {
  border-radius: 0 !important;
  background: transparent !important;
}

.md-fab,
.md-icon-button {
  border-radius: 0 !important;
  z-index: 999885 !important;
}

.md-caption.title {
  padding: 5px 10px;
}

.logout {
  border: 1px solid #555;
  height: 40px;
  margin: 30px auto;
}

.md-raised.md-dense {
  font: 14px;
  font-weight: 600;
}

.selectAll {
  text-align: left;
  padding-left: 3%;
}

.finalActions {
  text-align: left;
  margin: 20px 0 50px -10px;
}

.live {
  float: right !important;
}

.info.completed {
  background: #d4edda;
  color: #155724;
  border-color: #c3e6cb;
  max-height: 70px;
}

.sendGEA {
  float: right;
  margin-right: 0;
}

.md-checkbox-container {
  background-color: white;
}

.md-button.md-layout-item.md-raised.md-theme-default:not([disabled]).primary-color {
  color: #387a8f !important;
}

@media screen and (max-width: 1024px) {
  .md-layout-item.md-size-33 {
    min-width: 100% !important;
  }

  .status {
    order: 0;
    margin-top: 20px;
  }

  .spinner {
    margin-top: 25px;
  }
  .action {
    margin-top: 20px;
  }
  .selectAll {
    padding-left: 6%;
  }

  .finalActions {
    text-align: center;
  }

  .sendGEA {
    float: none;
  }
}

@media screen and (max-width: 667px) {
  .md-card .md-title {
    font-size: 20px;
    letter-spacing: 0;
    line-height: 24px;
    background: #fff !important;
  }

  .md-icon-button {
    border-radius: 0 !important;
    z-index: 9999999885 !important;
  }

  .md-layout {
    flex: 1;
  }
  .selectAll {
    padding-left: 20px;
  }

  .groups-list .md-checkbox {
    justify-content: flex-start;
  }
}
</style>
